<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Avaliar Relatório</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="$emit('onCloseReport')" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="4">
            <v-text-field
              v-model="report.municipio.nome"
              disabled
            ></v-text-field>
          </v-col>

          <v-col sm="4">
            <v-text-field
              v-model="report.encontro.grupo.nome"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col sm="3">
            <v-text-field
              v-if="
                estado === 'SC' ||
                estado === 'MS' ||
                estado === 'BA' ||
                estado === 'SP' ||
                estado === 'MA'
              "
              v-model="report.inicioString"
              v-mask="'##/##/#### ##:##'"
              label="Data de Início"
              placeholder="00/00/0000 00:00"
              disabled
            ></v-text-field>
          </v-col>

          <v-col sm="3">
            <v-text-field
              v-if="
                estado === 'SC' ||
                estado === 'MS' ||
                estado === 'BA' ||
                estado === 'SP' ||
                estado === 'MA'
              "
              v-model="report.fimString"
              v-mask="'##/##/#### ##:##'"
              label="Data de Término"
              placeholder="00/00/0000 00:00"
              disabled
            ></v-text-field>
          </v-col>

          <v-col sm="3">
            <v-text-field
              v-if="
                estado === 'SC' ||
                estado === 'MS' ||
                estado === 'BA' ||
                estado === 'SP' ||
                estado === 'MA'
              "
              v-model="report.horasUtilizadasString"
              v-mask="'##:##'"
              label="Horas Utilizadas"
              placeholder="00:00"
              disabled
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-tabs vertical>
            <v-tab>
              <v-icon left>mdi-file-chart</v-icon>
              Relatório
            </v-tab>
            <v-tab>
              <v-icon left>mdi-account-multiple-plus</v-icon>
              Convidados
            </v-tab>
            <v-tab>
              <v-icon left>mdi-attachment</v-icon>
              Anexos
            </v-tab>
            <v-tab
              v-if="
                estado === 'SC' ||
                estado === 'MS' ||
                estado === 'BA' ||
                estado === 'SP' ||
                estado === 'MA'
              "
            >
              <v-icon left>mdi-calendar-check-outline</v-icon>
              Tarefas
            </v-tab>
            <v-tab>
              <v-icon left>mdi-android-messages</v-icon>
              Observações
            </v-tab>

            <v-tab-item>
              <v-col>
                <v-textarea v-model="report.descricao" readonly></v-textarea>
              </v-col>
            </v-tab-item>
            <v-tab-item>
              <v-data-table
                :headers="headersConvidados"
                :items="report.convidados"
                class="elevation-1"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:item.presente="{ item }">
                  <v-checkbox
                    v-model="item.presente"
                    :id="'membro' + item.membroId"
                    color="primary"
                    disabled
                  >
                  </v-checkbox>
                </template>

                <template slot="no-data">
                  <span> Nenhum convidado retornado </span>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <v-data-table
                :headers="headersAnexos"
                :items="report.anexos"
                class="elevation-1"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:item.download="{ item }">
                  <v-btn
                    outlined
                    color="primary"
                    class="ml-3"
                    @click="downloadAnexo(item)"
                  >
                    <span>Download</span>
                  </v-btn>
                </template>

                <template slot="no-data">
                  <span> Nenhum anexo retornado </span>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item
              v-if="
                estado === 'SC' ||
                estado === 'MS' ||
                estado === 'BA' ||
                estado === 'SP' ||
                estado === 'MA'
              "
            >
              <v-data-table
                :headers="headers"
                :items="report.tarefas"
                class="elevation-1"
                hide-default-footer
                disable-pagination
              >
                <template v-slot:item.cumprida="{ item }">
                  <v-checkbox
                    v-model="item.cumprida"
                    :id="'cumprida' + item.tarefaId"
                    color="primary"
                    disabled
                  >
                  </v-checkbox>
                </template>
                <template
                  v-slot:item.tarefa.municipioTarefa.municipioEvidencias="{
                    item,
                  }"
                >
                  <span
                    v-for="evidencia in item.municipioTarefa
                      .municipioEvidencias"
                    :key="evidencia.municipioEvidenciaId"
                  >
                    {{ evidencia.nome }} |
                  </span>
                </template>

                <template slot="no-data">
                  <span> Nenhuma tarefa retornada </span>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <v-col>
                <v-textarea v-model="report.observacoes" readonly></v-textarea>
              </v-col>
            </v-tab-item>
          </v-tabs>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              label="Motivo da rejeição"
              v-model="report.motivoRejeicao"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="$emit('onCloseReport')"
          >Fechar</v-btn
        >
        <v-btn
          color="info"
          outlined
          text
          @click="save(2)"
          v-if="(isAdmin || isSPCoordenador) && report.statusRelatorioId !== 4"
          >Aprovar</v-btn
        >
        <v-btn
          color="info"
          outlined
          text
          @click="save(3)"
          v-if="(isAdmin || isSPCoordenador) && report.statusRelatorioId !== 4"
          >Rejeitar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { reportAPI } from "@/modules/report";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalAnalyseReport",
  props: {
    dialog: { type: Boolean, default: false },
    id: { type: Number, required: false },
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
    ]),
  },
  data() {
    return {
      headers: [
        { text: "Tarefa", value: "municipioTarefa.nome" },
        { text: "Cumprida", value: "cumprida" },
        {
          text: "Evidências",
          value: "tarefa.municipioTarefa.municipioEvidencias",
        },
      ],
      headersConvidados: [
        { text: "Nome", value: "convidado.nome" },
        { text: "CPF", value: "convidado.cpf" },
        { text: "E-mail", value: "convidado.email" },
        { text: "Presente", value: "presente" },
      ],
      headersAnexos: [
        { text: "Nome", value: "nome" },
        { text: "", value: "download" },
      ],
      estado: this.$store.state.uf,
      report: {
        arquivos: [],
        convidadosRelatorio: [],
        tarefasRelatorio: [],
        municipio: {},
        encontro: {
          grupo: {},
          solucoes: [{ numero: 0 }],
        },
      },
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    save(statusId) {
      if (statusId === 3 && !this.report.motivoRejeicao) {
        this.$notification.error("Favor inserir o motivo da rejeição");
      } else {
        this.setLoading(true);
        this.report.statusRelatorioId = statusId;
        let formData = new FormData();

        if (this.report.anexos.length > 0) {
          for (let i = 0; i < this.report.anexos.length; i++) {
            formData.append("arquivos", this.report.anexos[i]);
          }
        }

        formData.append("convidados", this.report.convidados);
        formData.append(
          "tarefasRelatorioString",
          JSON.stringify(this.report.tarefas)
        );
        formData.append(
          "municipio.nome",
          JSON.stringify(this.report.municipio.nome)
        );
        formData.append("convidadosRelatorio", this.report.convidadosRelatorio);
        formData.append("criacao", this.report.criacao);
        formData.append("criacaoString", this.report.criacao);
        formData.append("descricao", this.report.descricao);
        formData.append("encontro", this.report.encontro);
        formData.append("encontroId", JSON.stringify(this.report.encontroId));
        formData.append("fim", this.report.fim);
        formData.append("fimString", this.report.fimString);
        formData.append(
          "horasPrevistasString",
          this.report.horasPrevistasString
        );
        formData.append("horasTarefas", this.report.horasTarefas);
        formData.append(
          "horasUtilizadasString",
          this.report.horasUtilizadasString
        );
        formData.append("inicio", this.report.inicio);
        formData.append("inicioString", this.report.inicioString);
        formData.append("municipioId", JSON.stringify(this.report.municipioId));
        formData.append("relatorioId", JSON.stringify(this.report.relatorioId));
        formData.append(
          "statusRelatorioId",
          JSON.stringify(this.report.statusRelatorioId)
        );
        formData.append(
          "tipoExecucaoRelatorioId",
          this.report.tipoExecucaoRelatorioId
        );
        formData.append("titulo", this.report.titulo);
        if (this.report.motivoRejeicao) {
          formData.append("motivoRejeicao", this.report.motivoRejeicao);
        }
        if (this.report.complemento) {
          formData.append("complemento", this.report.complemento);
        }
        formData.append("usuarioId", this.report.usuarioId);

        reportAPI
          .analyse(formData)
          .then((resp) => {
            this.setLoading(false);
            this.$emit("onCloseReport", this.report);
          })
          .catch((resp) => {
            this.setLoading(false);
            this.$notification.error("Erro ao atualizar relatório");
          });
      }
    },
    get() {
      this.setLoading(true);
      reportAPI
        .get(this.id)
        .then((resp) => {
          this.report = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatório");
        });
    },
    downloadAnexo(evidencia) {
      reportAPI
        .downloadAnexo(evidencia.relatorioAnexoId)
        .then((resp) => {
          let blob = new Blob([resp.data], {
            type: resp.headers["content-type"],
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = evidencia.nome;
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter Anexo");
        });
    },
  },
  watch: {
    id: function () {
      this.get();
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
